import React from "react"

import renderElement from "../../utils/renderElement"

const TitleDescription = ({ article, isBlog }) => {
  const getClassName = () => {
    if (Number(article.alignment) === 1) {
      return "text-center "
    } else if (Number(article.alignment) === 0) {
      return "text-left"
    } else {
      return "text-right"
    }
  }
  return (
    <section className="title-description">
      <div className={isBlog ? " " : "container"}>
        <div className={getClassName()}>
          {article.title && (
            <h2
              className="mb-4"
              dangerouslySetInnerHTML={renderElement(article.title)}
            ></h2>
          )}
          {article.description && (
            <div
              dangerouslySetInnerHTML={renderElement(article.description)}
            ></div>
          )}
        </div>
      </div>
    </section>
  )
}

export default TitleDescription
